export default __webpack_public_path__ + "static/media/ic_avax_40.5e95ac88.svg";